import BulkTagsPopover from './BulkTagsPopover';
export default BulkTagsPopover;
